import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// import { CiSettings } from "react-icons/ci";
// import { CiSettings } from "react-icons/ci";
import { BiCog } from "react-icons/bi";


import { Box, Card, FormControl, Grid, TextField } from '@mui/material';
import { requiredLabel } from '../../../../../helpers/HelperFunctions';

export default function CustomizedDialogs(props) {

    const handleClose = () => {
        props.setOpen(false);
    };

    return (
        <React.Fragment>

            <Dialog
                onClose={handleClose}
                open={props.open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    <IconButton aria-label="close" sx={{ boxShadow: 2, borderRadius: 2 }} >
                        <BiCog />
                    </IconButton>
                    <Box>Legacy Configuration</Box>
                    <Typography> Manage Accounts for Teams Phone solution</Typography>
                </DialogTitle>

                <DialogContent sx={{p:2}}>

                    <Grid spacing={1}>
                        <Grid item xs={12}>
                            <FormControl fullWidth margin="normal">
                                <Typography>{requiredLabel('Domain', true)}</Typography>
                                <TextField
                                    name="domain"
                                    //   value={formData.domain}
                                    // disabled
                                    placeholder='abc.com'
                                    fullWidth
                                    size={'small'}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth margin="normal">
                                <Typography>{requiredLabel('Microsoft Admin Account', true)}</Typography>
                                <TextField
                                    name="microsoftAdminAccount"
                                    //   value={formData.domain}
                                    // disabled
                                    placeholder='abc.com'
                                    fullWidth
                                    size={'small'}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth margin="normal">
                                <Typography>{requiredLabel('password', true)}</Typography>
                                <TextField
                                    name="password"
                                    //   value={formData.domain}
                                    // disabled
                                    placeholder='abc'
                                    fullWidth
                                    type='password'
                                    size={'small'}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth margin="normal">
                                <Typography>{requiredLabel('Tenant ID', true)}</Typography>
                                <TextField
                                    name="tenantId"
                                    //   value={formData.domain}
                                    // disabled
                                    placeholder='uuid'
                                    fullWidth
                                    size={'small'}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Box display='flex' justifyContent="space-between" p={5} py={3}>
                    <Button variant='outlined' onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant='contained' onClick={handleClose}>
                        Save
                    </Button>
                </Box>
            </Dialog >
        </React.Fragment>
    );
}
